import {styled} from "@mui/material";

export const NoOrdersContainer = styled('div')(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    paddingTop: '3rem',
    paddingBottom: '3rem',
    gap: '1.5rem',
    color: theme.barekam.lightGrey,
    backgroundColor: '#fff'
}));

export const NoOrdersInfoContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
}));
